var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiagnomaticLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 346.72 42.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222323;}.cls-2{fill:#5fabc7;}.cls-3{fill:#6cc2e1;}.cls-4{fill:#73caeb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diagnomatic_logo",
    "data-name": "Diagnomatic logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,40.81V1.86H8.06q9.45,0,15.65,5t6.2,14.28q0,9.56-6.15,14.62T7.9,40.81ZM4.86,6.31V36.37h1.7a30.18,30.18,0,0,0,7.13-.78,18.29,18.29,0,0,0,5.81-2.48,11.5,11.5,0,0,0,4.08-4.7,15.87,15.87,0,0,0,1.47-7.08,16,16,0,0,0-1.47-7.12,11.3,11.3,0,0,0-4.11-4.68,19.41,19.41,0,0,0-5.81-2.45,29.77,29.77,0,0,0-7.1-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.47,1.86v39H34.61V1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.11,21.18h15.44v1.55a18.78,18.78,0,0,1-5.16,13.51,17.57,17.57,0,0,1-13.28,5.4,18.57,18.57,0,0,1-13.89-6,19.78,19.78,0,0,1-5.79-14.18A19.78,19.78,0,0,1,86.34,7a19.35,19.35,0,0,1,14.29-6,20.5,20.5,0,0,1,8.81,2,19.71,19.71,0,0,1,7,5.56l-3.41,3.25a15.53,15.53,0,0,0-5.43-4.62,14.42,14.42,0,0,0-6.81-1.73,14.82,14.82,0,0,0-11,4.62,15.39,15.39,0,0,0-4.53,11.18,15.9,15.9,0,0,0,4.47,11.09,14.05,14.05,0,0,0,10.67,4.83,13,13,0,0,0,8.63-3.46,11,11,0,0,0,4.13-8.12H103.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.19,7A20.32,20.32,0,0,1,196,7a19.48,19.48,0,0,1,6,14.33A19.47,19.47,0,0,1,196,35.8a20.83,20.83,0,0,1-28.93,0,19.47,19.47,0,0,1-5.94-14.47A19.44,19.44,0,0,1,167.19,7Zm3.43,25.52a15.42,15.42,0,0,0,21.91,0,15.19,15.19,0,0,0,4.59-11.19,15.5,15.5,0,0,0-4.41-11.15,15.78,15.78,0,0,0-22.27,0A15.5,15.5,0,0,0,166,21.33,15.19,15.19,0,0,0,170.62,32.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225,41.64,213.29,15.09h-.1l-4.55,25.72h-5l8-40.6L225,30.89,238.35.21l8,40.6h-5l-4.54-25.72h-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.31,6.31v34.5h-4.86V6.31h-9.24V1.86h23.35V6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.08,1.86v39h-4.86V1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.72,3.67V9.3a14.89,14.89,0,0,0-10.28-3.82,14.55,14.55,0,0,0-10.92,4.67,15.68,15.68,0,0,0-4.47,11.24,15.64,15.64,0,0,0,4.42,11.13,14.36,14.36,0,0,0,10.87,4.68,15.06,15.06,0,0,0,10.38-4V38.9a20.49,20.49,0,0,1-24.56-3.1,19.17,19.17,0,0,1-6-14.25A19.67,19.67,0,0,1,322.24,7,20.15,20.15,0,0,1,336.91,1,18.31,18.31,0,0,1,346.72,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.89,40.81V0l29.24,30.63V1.86H157V42.41L127.75,11.78v29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.21 0.21 42.62 40.81 47.83 40.81 48.82 38.64 58.84 16.25 58.84 16.25 61.21 10.85 68.14 26.61 57.33 26.61 55.34 31.05 70.15 31.05 74.59 40.81 79.81 40.81 61.21 0.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "265.11 0.21 246.51 40.81 251.73 40.81 255.09 33.41 260.62 21.07 265.11 10.85 272.03 26.61 261.26 26.61 259.27 31.05 274.04 31.05 278.48 40.81 283.7 40.81 265.11 0.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 178.18,
    y: 11.05,
    width: 6.8,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 178.18,
    y: 24.65,
    width: 6.8,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 178.18,
    y: 17.85,
    width: 6.8,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 184.97,
    y: 17.85,
    width: 6.8,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 171.38,
    y: 17.85,
    width: 6.8,
    height: 6.8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnomaticLogo);
export default __webpack_public_path__ + "static/media/diagnomatic-logo.fad637157b377e201644600f53722023.svg";
export { ForwardRef as ReactComponent };